import { atom } from 'jotai';

export const brokerIdAtom = atom <string | undefined>(undefined);
